import {
  baseServiceInvoiceSchema,
  ServiceInvoiceType,
} from "@redotech/redo-billing-common/service-invoice";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const marketingInvoiceTypes = [
  ServiceInvoiceType.MARKETING_EMAIL,
  ServiceInvoiceType.MARKETING_SMS,
] as const satisfies ServiceInvoiceType[];

export const getFinalizedServiceInvoices = {
  name: "getFinalizedServiceInvoices" as const,
  input: z.null(),
  output: z.array(
    baseServiceInvoiceSchema.extend({
      type: createEnum(marketingInvoiceTypes, {
        enumName: "MarketingInvoiceType",
      }),
    }),
  ),
};
